import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { LogoItem, Image, Name } from "./logos-module.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Logo = function Logo(_ref) {
  var height = _ref.height,
    url = _ref.url,
    isCurrent = _ref.isCurrent,
    name = _ref.name,
    showName = _ref.showName,
    width = _ref.width;
  return /*#__PURE__*/_jsxs(LogoItem, {
    isActive: isCurrent,
    logoWidth: width,
    children: [/*#__PURE__*/_jsx(Image, {
      height: height,
      alt: name,
      src: url
    }), showName && /*#__PURE__*/_jsx(Name, {
      children: name
    })]
  });
};
Logo.propTypes = {
  height: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  isCurrent: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  showName: PropTypes.bool.isRequired,
  width: PropTypes.number.isRequired
};
Logo.displayName = 'Logo';
export default /*#__PURE__*/memo(Logo);